// extracted by mini-css-extract-plugin
export default {"limit":"DataTable_limit__xSVQp","pagination_row":"DataTable_pagination_row__9bNH+"};